import { createFileRoute } from "@tanstack/react-router";
import { requireSurface } from "../-guards";

// /staff/dashboard — the administrator's landing screen after login.
//
// DELIBERATELY EMPTY. The product pivoted and the admin side is being rebuilt one screen at a
// time; this route exists so an administrator lands inside the app shell (Figma 325:23202) with
// the sidebar and account card in place, and nothing else. It is the "Tableau de bord" entry the
// design puts under GÉNÉRAL, ahead of the screen itself.
//
// No `staticData.breadcrumb`: the design replaced the breadcrumb row with a page header, and the
// Breadcrumb component renders nothing when no route declares a trail — so the well stays clean
// until this screen gets a header of its own.
//
// Guarded on the same surface as the rest of the staff screens, so nav visibility and route
// access can never disagree.
export const Route = createFileRoute("/staff/dashboard")({
  beforeLoad: ({ context, location }) =>
    requireSurface(
      context.queryClient,
      "round_configuration",
      location.pathname
    ),
  component: () => null,
});
